import { makeStyles } from "@mui/styles";
import { DRAWER_WIDTH, HEADER_HEIGHT } from "../../../constants/ui";

export default makeStyles((theme) => ({
  appBarContainer: {
    position: "fixed",
    left: 0,
    right: 0,
    zIndex: "1300 !important",
    boxShadow: "0 10px 30px 0 rgba(82,63,105,.08) !important",
    // borderLeftTopRadius: 50,
    overflow: "hidden",
    height: HEADER_HEIGHT,
  },

  breadcrumbsContainer: {
    position: "absolute",
    zIndex: 5,
    bottom: 0,
    left: 0,
    paddingLeft: 30,
    paddingRight: 40,
    backgroundColor: theme.palette.header.breadcrumbsBackground,
    borderTopRightRadius: 40,
    borderTopLeftRadius: 40,
  },

  avatar: {
    zIndex: 1,
    transition: "300ms",
    // position: "absolute !important",
    // right: 20,
    // top: 12,
    borderRadius: "50%",
    width: "45px !important",
    minWidth: "45px !important",
    height: "45px !important",
    backgroundColor: "#fff",
    overflow: "hidden",

    boxShadow: "0 -1px 10px rgba(0, 0, 0, 0.2) !important",
    // "& $svg": {
    //   borderRadius: "50% !important",
    // },
    "&:hover": {
      cursor: "pointer",
      transition: "300ms",
      boxShadow: "0 -1px 12px rgba(0, 0, 0, 0.4) !important",
    },

    [theme.breakpoints.up("sm")]: {
      width: "50px !important",
      height: "50px !important",
      top: 8,
    },
  },
  headerImage: {
    position: "absolute",
    right: -20,
    bottom: -140,
    zIndex: -1,
    // width: 300,
    height: 50,
    opacity: 0.6,
    transform: "rotate(-140deg)",
    [theme.breakpoints.up("lg")]: {
      height: 300,
    },
  },
  navbarTitle: {
    zIndex: 5,
    minWidth: 80,
  },

  appBar: {
    // backgroundColor: theme.palette.header.background,
    height: "100%",
  },

  logo: {
    height: "2rem",
    [theme.breakpoints.up("sm")]: {
      height: "2.2rem !important",
    },
  },

  title: {
    fontSize: "1.2rem !important",
    lineHeight: "1 !important",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.5rem !important",
      fontWeight: "600 !important",
    },
  },

  subtitle: {
    fontSize: "0.6rem !important",
    fontWeight: "400 !important",
    lineHeight: "15px !important",
    letterSpacing: "0.00938em !important",
    [theme.breakpoints.up("sm")]: {
      fontSize: "0.7rem !important",
    },
  },
  menuIcon: {
    color: theme.palette.primary.main,
    zIndex: 10,
  },
  menuIconDisabled: {
    color: `${theme.palette.primary.disabled} !important`,
    zIndex: 10,
  },
}));
